{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Transferă către operator",
    "MESSAGE": "Transferă-mă către un operator"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Descărcare",
      "UPLOADING": "Încărcare..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Trimite"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Trimiteți din nou un mesaj",
      "ERROR_MESSAGE": "Nu s-a putut trimite! Încearcă din nou"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Evaluați calitatea acestui răspuns"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Vă rugăm să așteptați ca un agent să se alăture"
  },
  "ROBOT_CHECK": {
    "TITLE": "Verificare rapidă de securitate",
    "DESCRIPTION": "Vă rugăm să completați verificarea de mai jos.",
    "VERIFYING": "Se verifică…",
    "ERROR": "Nu a funcționat. Vă rugăm să încercați din nou.",
    "RETRY": "Încearcă din nou"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Suntem online",
    "OFFLINE": "Suntem plecați în acest moment",
    "ONLINE_WITH_BOT": "Echipa și asistentul nostru AI sunt online",
    "OFFLINE_WITH_BOT": "Asistentul nostru AI este aici pentru a ajuta",
    "BOT_ONLY_REPLY": "Răspunde imediat"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "De obicei, răspunsurile în câteva minute",
    "IN_A_FEW_HOURS": "De obicei, răspunsurile în câteva ore",
    "IN_A_DAY": "De obicei, răspunsurile într-o zi",
    "BACK_IN": "Vom reveni online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Duminică",
    "MONDAY": "Luni",
    "TUESDAY": "Marți",
    "WEDNESDAY": "Miercuri",
    "THURSDAY": "Joi",
    "FRIDAY": "Vineri",
    "SATURDAY": "Sâmbătă"
  },
  "START_CONVERSATION": "Începe conversația",
  "END_CONVERSATION": "Terminați conversația",
  "CONTINUE_CONVERSATION": "Continuați conversația",
  "YOU": "Dumneavoastră",
  "START_NEW_CONVERSATION": "Începeți o conversație nouă",
  "RESOLVE_LATER": "Vom rezolva acest subiect prin e-mail/telefon. Acum vreau să întreb despre altceva.",
  "VIEW_UNREAD_MESSAGES": "Aveți mesaje necitite",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Vezi mesajele noi",
    "CLOSE_MESSAGES_BUTTON": "Închide",
    "COMPANY_FROM": "de la",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Discută cu noi"
  },
  "POWERED_BY": "Oferit de {brandName}",
  "EMAIL_PLACEHOLDER": "Te rugăm să introduci adresa de e-mail",
  "CHAT_PLACEHOLDER": "Scrie mesajul tău",
  "TODAY": "Astăzi",
  "YESTERDAY": "Ieri",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Nume complet",
        "PLACEHOLDER": "Te rugăm să introduci un nume valid",
        "REQUIRED_ERROR": "Este necesar numele complet"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Adresa Email",
        "PLACEHOLDER": "Te rugăm să-ți introduci adresa de email",
        "REQUIRED_ERROR": "Adresa de e-mail este obligatorie",
        "VALID_ERROR": "Vă rugăm să introduceți o adresă de e-mail validă"
      },
      "PHONE_NUMBER": {
        "LABEL": "Număr de telefon",
        "PLACEHOLDER": "Te rugăm să introduci numărul de telefon",
        "REQUIRED_ERROR": "Numărul de telefon este obligatoriu",
        "DIAL_CODE_VALID_ERROR": "Vă rugăm să selectați un prefix de țară",
        "VALID_ERROR": "Vă rugăm să introduceți un număr de telefon valid",
        "DROPDOWN_EMPTY": "Niciun rezultat găsit",
        "DROPDOWN_SEARCH": "Căutați țara"
      },
      "MESSAGE": {
        "LABEL": "Mesaj",
        "PLACEHOLDER": "Introdu mesajul tău",
        "ERROR": "Mesaj prea scurt"
      }
    },
    "CAMPAIGN_HEADER": "Vă rugăm să furnizați numele și e-mailul înainte de a începe conversația",
    "IS_REQUIRED": "este obligatoriu",
    "REQUIRED": "Necesar",
    "REGEX_ERROR": "Vă rugăm să introduceți o valoare validă"
  },
  "FILE_SIZE_LIMIT": "Fisierul depaseste limita de {MAXIMUM_FILE_UPLOAD_SIZE} atasamente",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Câmp invalid"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Caută emoji-uri",
    "NOT_FOUND": "Niciun emoji nu corespunde căutării tale",
    "ARIA_LABEL": "Selector de emoji"
  },
  "CSAT": {
    "TITLE": "Evaluează conversația ta",
    "SUBMITTED_TITLE": "Vă mulțumim pentru trimiterea de rating",
    "PLACEHOLDER": "Spune-ne mai mult..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Solicitați o transcriere a conversației",
    "SEND_EMAIL_SUCCESS": "Transscrisul de chat a fost trimis cu succes",
    "SEND_EMAIL_ERROR": "A apărut o eroare, încercați din nou"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Articole populare",
    "VIEW_ALL_ARTICLES": "Vezi toate articolele",
    "IFRAME_LOAD_ERROR": "A apărut o eroare la încărcarea articolului. Vă rugăm să reîmprospătați pagina și să încercați din nou."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Deschide",
      "BUY": "Cumpără"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Mesaj imagine"
    },
    "audio": {
      "CONTENT": "Mesaj audio"
    },
    "video": {
      "CONTENT": "Mesaj video"
    },
    "file": {
      "CONTENT": "Fişier ataşat"
    },
    "location": {
      "CONTENT": "Locaţie"
    },
    "fallback": {
      "CONTENT": "a partajat un URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Răspuns la:"
  }
}
